
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.361","height":"22.611"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.311 20.437a1.135 1.135 0 01-2.262 0 .566.566 0 00-1.131 0 2.264 2.264 0 004.525 0 .566.566 0 00-1.131 0M5.091 8.368a.566.566 0 101.131 0 3.958 3.958 0 013.959-3.959.566.566 0 000-1.131 5.091 5.091 0 00-5.09 5.09m-1.131.084a6.222 6.222 0 0112.443 0v5.688h-6.229a.566.566 0 000 1.131h6.632a.518.518 0 00.162.025.508.508 0 00.162-.025h.969a1.131 1.131 0 110 2.262H2.264a1.131 1.131 0 010-2.262h3.39a.566.566 0 000-1.131h-1.69zm4.576-7.167a7.355 7.355 0 00-5.707 7.167v5.688h-.565a2.263 2.263 0 000 4.525h15.837a2.263 2.263 0 100-4.525h-.566V8.452a7.355 7.355 0 00-5.707-7.167 1.7 1.7 0 00-3.292 0","fill":"#73889f"}})])
          )
        }
      }
    